import { Strong, Text } from '@clay-run/glaze/text';
import type { NoteTarget } from '@shared/flow/notes';
import { noteTargetKey } from '@shared/flow/notes';
import { NotesRecordSearch } from './NotesHeader';
import { RAIL_PANE_GAP } from '../rail/RailSearchRow';
import { useFlowNotesStore, type FlowNotesState } from './flow-notes-store';

/** A recent's name from the search rows we kept; plain words when it was opened some other way. */
function recentLabel(target: NoteTarget, contactRows: FlowNotesState['contactRows']): string {
  if (target.kind === 'contact') return contactRows[target.id]?.name ?? 'Contact';
  const row = Object.values(contactRows).find(r => r.account_id === target.id);
  return row?.account_name ?? 'Account';
}

/** Notes tab with no record open: the record search up front and recent threads under it. */
export function NotesStart() {
  const recents = useFlowNotesStore(s => s.recents);
  const contactRows = useFlowNotesStore(s => s.contactRows);
  return (
    <div className={`flex flex-col ${RAIL_PANE_GAP}`}>
      <div className="flex flex-col gap-0.5">
        <Strong className="text-sm">Notes</Strong>
        <Text size="xs" variant="tertiary">
          Search for an account or contact to open its notes.
        </Text>
      </div>
      <NotesRecordSearch activeEntity="account" />
      {recents.length > 0 && (
        <div className="flex flex-col gap-1">
          <Text size="xs" variant="tertiary">
            Recent
          </Text>
          <ul aria-label="Recent" className="flex flex-col gap-0.5">
            {recents.map(recent => (
              <li key={noteTargetKey(recent)}>
                <button
                  type="button"
                  className="flex h-8 w-full items-center rounded-md px-2 text-left text-sm text-content-primary hover:bg-bg-secondary"
                  onClick={() => useFlowNotesStore.getState().openTarget(recent)}
                >
                  <span className="truncate">{recentLabel(recent, contactRows)}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
